import DataRoomUploadActions from './DataRoomUploadActions.component';

export default DataRoomUploadActions;
